import { gql } from 'graphql-request';

export const CRONOFY_INITIALIZE_CONNECT = gql`
  query cronofyInitializeConnect {
    cronofyInitializeConnect {
      auth_url
    }
  }
`;

export const CRONOFY_DISCONNECT_PROFILE = gql`
  mutation cronofyDisconnectProfile($profileId: String!) {
    cronofyDisconnectProfile(profileId: $profileId) {
      ok
    }
  }
`;

export const CRONOFY_GET_PROFILES = gql`
  query cronofyProfiles {
    cronofySyncProfiles {
      id
      provider
      name
      relinkUrl
      initializing
      outboundSyncCalendarId
      calendars {
        id
        name
        inboundSync
        readonly
      }
    }
  }
`;

export const CRONOFY_GET_EVENTS = gql`
  query cronofyEvents($calendarsIds: [String!]!, $fromDt: DateTime!, $toDt: DateTime!) {
    cronofyEvents(calendarsIds: $calendarsIds, fromDt: $fromDt, toDt: $toDt)
  }
`;

export const CRONOFY_SET_INBOUND_SYNC = gql`
  mutation cronofySetInboundSync($profileId: String!, $calendarId: String!, $enabled: Boolean!) {
    cronofySetInboundSync(profileId: $profileId, calendarId: $calendarId, enabled: $enabled) {
      ok
    }
  }
`;

export const CRONOFY_SET_OUTBOUND_SYNC = gql`
  mutation cronofySetOutboundSync($profileId: String!, $calendarId: String) {
    cronofySetOutboundSync(profileId: $profileId, calendarId: $calendarId) {
      ok
    }
  }
`;

export const CRONOFY_SYNC_EVENT = gql`
  mutation cronofySyncEvent($eventId: String!, $eventType: EventTypeEnum!, $deleted: Boolean) {
    cronofySyncEvent(eventId: $eventId, eventType: $eventType, deleted: $deleted) {
      ok
    }
  }
`;

export const CRONOFY_SYNC_EVENT_MANY = gql`
  mutation cronofySyncEventMany($events: [EventManyType]!) {
    cronofySyncEventMany(events: $events) {
      ok
    }
  }
`;

export const CRONOFY_REQUEST_EXTENDED_PERMISSIONS = gql`
  mutation cronofyRequestExtendedPermissions($calendarIds: [String!]!) {
    cronofyCalendarRequestExtendedPermissions(calendar_ids: $calendarIds) {
      accepted
      message
      redirect_url
      status
    }
  }
`;

export const CRONOFY_CHECK_CALENDAR_PERMISSIONS = gql`
  query cronofyCalendarPermissions($calendarIds: [String!]!) {
    cronofyCalendarPermissions(calendarIds: $calendarIds) {
      calendars {
        calendarId
        hasUnrestrictedAccess
        permissionLevel
        calendarName
        readonly
        error
      }
    }
  }
`;

export const CRONOFY_HANDLE_PERMISSIONS_CALLBACK = gql`
  mutation cronofyHandleExtendedPermissionsCallback($success: Boolean!, $error: String) {
    cronofyHandleExtendedPermissionsCallback(success: $success, error: $error) {
      result {
        status
        message
      }
    }
  }
`;

export const CRONOFY_BATCH_MANAGE_EXTERNAL_EVENTS = gql`
  mutation cronofyBatchManageExternalEvents($calendarId: String!, $operations: [ExternalEventOperationType!]!) {
    cronofyBatchManageExternalEvents(calendarId: $calendarId, operations: $operations) {
      result {
        status
        message
        operationsCount
        errors
      }
    }
  }
`;

export const CRONOFY_MANAGE_EXTERNAL_EVENT = gql`
  mutation cronofyManageExternalEvent(
    $calendarId: String!
    $eventId: String!
    $operation: String!
    $eventData: ExternalEventDataType
  ) {
    cronofyManageExternalEvent(
      calendarId: $calendarId
      eventId: $eventId
      operation: $operation
      eventData: $eventData
    ) {
      ok
    }
  }
`;

export const BULK_UPDATE_EVENTS_PRIVACY = gql`
  mutation cronofyBulkUpdateEventsPrivacy {
    cronofyBulkUpdateEventsPrivacy {
      ok
      message
    }
  }
`;
